/**
 *  [2023] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

/**
 * :ZNOTE:
 * tag: デバッグ,debug,スタックトレース,stack trace
 * note:
 *  - スタックトレースをconsole.logに出力する
 * sample:
 *  -
 * :ZNOTE:
 */

const printStackTrace = () => {
  try {
    throw new Error('スタックトレースのデバッグ出力です（エラーではない）');
  } catch (e: any) {
    if (e.stack) {
      // 出力方法は、使いやすいように修正する。
      console.log(e.stack);
    } else {
      // stackがない場合には、そのままエラー情報を出す。
      console.log(e.message, e);
    }
  }
};

export {
  printStackTrace
};
